module.exports = "/images/pin-unknown-active.png?6f89a4f84d8bfdd387c8ec443f925410";